var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueTagsInput',{attrs:{"tags":_vm.tags,"disabled":_vm.disabled,"autocomplete-items":_vm.filteredItems,"placeholder":_vm.$t('firewall.addSource')},on:{"before-deleting-tag":_vm.beforeDeleteSource,"before-adding-tag":_vm.beforeAddingSource,"tags-changed":_vm.tagsChanged},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098e2d27","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/firewalls/SourceTags.vue
// module id = YMFt
// module chunks = 35